import React from 'react';

export interface ModalBodyProps {
  children: React.ReactNode;
}

/**
 * Modal body component with scrollable content area.
 * Encapsulates overflow and spacing behavior.
 */
export const ModalBody: React.FC<ModalBodyProps> = ({ children }) => {
  return (
    <div className="px-8 py-6 overflow-y-auto max-h-[calc(80vh-120px)]">
      {children}
    </div>
  );
};
